import GenericBody from "../Componentes/GenericBody"
import NavBar from "../Componentes/NavBar"
import { useModal } from "../contexts/ModalContext";
import BodyContent from "../Modulos/SolicitacaoPassagem/BodyContent";

const SolicitacaoPassagem = () => {

    const { openModal } = useModal();

    const openSideBar = () => {
        openModal("solicPassagemSidebar");
    }

    return (
        <>
            <NavBar title="SOLICITAÇÃO DE PASSAGEM" setSideBar={openSideBar} modulo="rh" />
            <GenericBody>
                <BodyContent />
            </GenericBody>
        </>
    )

}

export default SolicitacaoPassagem;
